import { store } from "../../../store/store";
import * as actionTypes from "../../../store/actions";

export function resetRedux() {
    store.dispatch({
        type: actionTypes.RESET_STORE,
    })
}

export function updateUserDetails(userObj) {
    store.dispatch({
        type: actionTypes.UPDATE_USER_DETAILS,
        query: userObj
    })
}

export function updateTokenInfo(token) {
    store.dispatch({
        type: actionTypes.UPDATE_USER_TOKEN,
        query: token
    })
}

export function updateGuestToken(token) {
    store.dispatch({
        type: actionTypes.UPDATE_GUEST_TOKEN,
        query: token
    })
}

export function updateLoginStatus(isLogin) {
    store.dispatch({
        type: actionTypes.UPDATE_LOGIN_STATUSS,
        query: isLogin
    })
}

export function updateFamilyData(familyData) {
    store.dispatch({
        type: actionTypes.UPDATE_FAMILY_DETAILS,
        query: familyData
    })
}

export function updateProfileStatus(profileStatus) {
    store.dispatch({
        type: actionTypes.UPDATE_PROFILE_STATUS,
        query: profileStatus
    })
}

export function updateWAOptInState(optInState) {
    store.dispatch({
        type: actionTypes.UPDATE_WA_OPTIN_STATE,
        query: optInState
    })
}

export function updateWalletDetails(walletBalance) {
    store.dispatch({
        type: actionTypes.UPDATE_WALLET_DATA,
        query: walletBalance
    })
}

export function updateUserSubscription(aayuCardSubscription) {
    store.dispatch({
        type: actionTypes.UPDATE_SUBSCRIPTION_DATA,
        query: aayuCardSubscription
    })
}

export function updateReduxReviews(reviews) {
    store.dispatch({
        type: actionTypes.UPDATE_REVIEWS,
        query: reviews
    })
}

export function updateReduxAayuCardPlans(aayuCardPlans) {
    store.dispatch({
        type: actionTypes.UPDATE_AAYU_PLANS,
        query: aayuCardPlans
    })
}

export function updateReduxAayuCardAllPlans(aayuCardAllPlans) {
    store.dispatch({
        type: actionTypes.UPDATE_AAYU_ALL_PLANS,
        query: aayuCardAllPlans
    })
}

export function updateReduxPremiumAayuCard(aayuCardPlans) {
    store.dispatch({
        type: actionTypes.UPDATE_PREMIUM_AAYU_PLAN,
        query: aayuCardPlans
    })
}

export function updateConsultationParam(params) {
    store.dispatch({
        type: actionTypes.UPDATE_CONSULT_PARAMS,
        query: params
    })
}

export function updateReduxCurrentQuestion(params) {
    store.dispatch({
        type: actionTypes.UPDATE_CURRENT_QUESTION,
        query: params
    })
}

export function updateReduxCurrentAnswer(params) {
    store.dispatch({
        type: actionTypes.UPDATE_CURRENT_ANSWER,
        query: params
    })
}

export function updateReduxQuestionList(params) {
    store.dispatch({
        type: actionTypes.UPDATE_QUESTION_LIST,
        query: params
    })
}

export function updateReduxAnswerList(params) {
    store.dispatch({
        type: actionTypes.UPDATE_ANSWER_LIST,
        query: params
    })
}

export function updateQuestionRenderState(params) {
    store.dispatch({
        type: actionTypes.UPDATE_QUESTIONRENDER_STATE,
        query: params
    })
}

export function updateReduxImageList(params) {
    store.dispatch({
        type: actionTypes.UPDATE_IMAGE_LIST,
        query: params
    })
}

export function updateReduxEConsultInfo(params) {
    store.dispatch({
        type: actionTypes.UPDATE_ECONSULT_INFO,
        query: params
    })
}

export function updateSelectedAayucard(params) {
    store.dispatch({
        type: actionTypes.UPDATE_SELECTED_AAYU_CARD,
        query: params
    })
}

export function updateAddUpdateScreenData(params) {
    store.dispatch({
        type: actionTypes.UPDATE_ADD_UPDATE_SCREEN_DATA,
        query: params
    })
}

export function updateIsDashboardLaoded(params) {
    store.dispatch({
        type: actionTypes.UPDATE_DASHBOARD_LOADED_STATUS,
        query: params
    })
}

export function updateUserLoginDetails(params) {
    store.dispatch({
        type: actionTypes.UPDATE_USER_LOGIN_DETAILS,
        query: params
    })
}

export function updateConsultationList(params) {
    store.dispatch({
        type: actionTypes.UPDATE_CONSULTATIONS_LIST,
        query: params
    })
}

export function updateOrderList(params) {
    store.dispatch({
        type: actionTypes.UPDATE_ORDER_LIST,
        query: params
    })
}

export function updateUserSelectedLocationToRedux(params) {
    store.dispatch({
        type: actionTypes.UPDATE_SELECTED_LOCATION,
        query: params
    })
}

export function updateSearchedLocationHistory(params) {
    store.dispatch({
        type: actionTypes.UPDATE_PREVIOUS_SELECTED_LOCATION,
        query: params
    })
}

export function updateAutoCompleteSearchHistory(params) {
    store.dispatch({
        type: actionTypes.UPDATE_PREVIOUS_SELECTED_MEDICINE_CATEGORY,
        query: params
    })
}

export function updateSearchedMedicineHistory(params) {
    store.dispatch({
        type: actionTypes.UPDATE_PREVIOUS_SELECTED_MEDICINE,
        query: params
    })
}

export function updateChemistData(params) {
    store.dispatch({
        type: actionTypes.UPDATE_PHARMACY_DATA,
        query: params
    })
}

export function updateSelectedStore(params) {
    store.dispatch({
        type: actionTypes.UPDATE_SELECTED_STORE,
        query: params
    })
}

export function updateMessagesDownloadImageListToRedux(params) {
    store.dispatch({
        type: actionTypes.UPDATE_DOWNLOADED_CHAT_IMAGES_LIST,
        query: params
    })
}

export function updateCartsItemsListToRedux(params) {
    if (params && params.constructor !== Array)
        throw TypeError('Expecting array type.')
    store.dispatch({
        type: actionTypes.UPDATE_OMS_CART_ITEMS,
        query: JSON.stringify(params)
    })
}

export function updateCartImagesListToRedux(params) {
    store.dispatch({
        type: actionTypes.UPDATE_OMS_IMAGES_DATA,
        query: JSON.stringify(params)
    })
}

export function updateRepeatOrderDataToRedux(params) {
    store.dispatch({
        type: actionTypes.UPDATE_OMS_REPEAT_ORDER,
        query: params
    })
}

export function updateOrderInstructions(params) {
    store.dispatch({
        type: actionTypes.UPDATE_ORDER_INSTRUCTIONS_TO_PHARMACY,
        query: params
    })
}

export function updateUserVisitedStores(params) {
    store.dispatch({
        type: actionTypes.UPDATE_USER_VISITED_CHEMIST_SITE,
        query: params
    })
}